import React from 'react';
import MapContainer from '../map/container';
import MapButtonsIcon from '../mapbuttons/containerIconBtt';
import BaseLayersContainer from '../baseLayers/container';
import MapPopupContainer from '../mapPopup/container';
import ContextMenu from '../contextmenu/container';

const App = () => (
	<div style={{ position: 'relative' }}>
		<MapContainer />
		<div
			style={{
				flexWrap: 'wrap',
				position: 'absolute',
				pointerEvents: 'none',
				top: 0,
				right: 5,
				padding: 10,
				display: 'flex',
				justifyContent: 'space-between',
				pointerEvents: 'auto',
			}}>
			<BaseLayersContainer />
		</div>
		<div
			style={{ position: 'absolute', bottom: '32px', left: '8px', cursor: 'pointer' }}
			onClick={() => window.open('https://www.kartes.lv/', '_blank')}>
			<img style={{ height: 30 }} src={'https://vietvardi.kartes.lv/draw/logo.png'}></img>
		</div>

		<div style={{ position: 'absolute', bottom: '10px', right: '20px', pointerEvents: 'none' }}>
			<div style={{ display: 'flex', alignItems: 'flex-end' }}>
				<div style={{ pointerEvents: 'auto' }}>
					<MapButtonsIcon />
				</div>
			</div>
		</div>
		<ContextMenu />
		<MapPopupContainer />
	</div>
);

export default App;
